import { Monitor } from 'lucide-react';

/**
 * Dashboards are desktop-only for now. On `md+` the children render; below that
 * breakpoint a friendly notice is shown instead. (The route is also kept out of
 * the mobile BottomNav, so this only triggers on a direct/narrow visit.)
 */
export function DesktopOnly({
  children,
  title = 'Dashboards are available on desktop',
  message = 'Open Cosmos on a larger screen to view the dashboards. The mobile app focuses on tickets and opportunities.',
}: {
  children: React.ReactNode;
  title?: string;
  message?: string;
}) {
  return (
    <>
      <div className="hidden md:block">{children}</div>
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center md:hidden">
        <Monitor className="h-10 w-10 text-muted-foreground" />
        <div className="text-sm font-medium text-foreground">{title}</div>
        <p className="max-w-xs text-xs text-muted-foreground">{message}</p>
      </div>
    </>
  );
}
